import React from "react";
import { Box } from "@mui/material";
import { TOKENS, monoFor, initials } from "./tokens";

/**
 * Colored square initials chip derived from `name`.
 */
const Monogram = ({ name = "", size = 36, radius = 10 }) => {
  const [bg, ink] = monoFor(name);
  const label = initials(name) || "·";
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: `${radius}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: bg,
        color: ink,
        fontWeight: 700,
        fontSize: Math.max(11, Math.round(size * 0.36)),
        letterSpacing: "0.02em",
        flexShrink: 0,
        border: `1px solid ${TOKENS.borderSubtle}`,
      }}
    >
      {label}
    </Box>
  );
};

export default Monogram;
